import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import Slider from '@mui/material/Slider';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import Tooltip from '../components/Tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import AlgoQuickManage from '../manage/AlgoQuickManage.js';
import ActionResult from '../components/ActionResult.js';
import AlgoDrawer from '../algos/AlgoDrawer.js'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Drawer from '@mui/material/Drawer';


function AlgoStats(props) {
    const [data, setData] = useState([]);
    const [years, setYears] = useState(props.defaultYears ? props.defaultYears : 0);
    const [updates, setUpdates] = useState(1);
    const [filtered, setFiltered] = useState(!props.showAll)
    const [recommendations, setRecommendations] = useState(null)
    const [searchSymbol, setSearchSymbol] = useState('');
    const [searchAlgoType, setSearchAlgoType] = useState('Mean Reversion');
    const [searchMaxCorrelation, setSearchMaxCorrelation] = useState('60');

    const [winRateFilter, setWinRateFilter] = React.useState([0, 100]);
    const [durationFilter, setDurationFilter] = React.useState([0, 300]);
    const [avgProfitFilter, setAvgProfitFilter] = React.useState([-100, 100]);
    const [tradeCountFilter, setTradeCountFilter] = React.useState([0, 300]);
    const [robustnessFilter, setRobustnessFilter] = React.useState([0, 10]);
    const [symbolFilter, setSymbolFilter] = React.useState(null);
    const [algoFilter, setAlgoFilter] = React.useState(null);
    const [algoTypeFilter, setAlgoTypeFilter] = React.useState(null);
    const [algoLongShortFilter, setAlgoLongShortFilter] = React.useState(null);
    const [activeTrades, setActiveTrades] = useState([]);
    const [savedSearches, setSavedSearches] = useState([]);
    const [activeSavedQuery, setActiveSavedQuery] = useState(null);
    const [saveSearchName, setSaveSearchName] = useState("");
    const [result, setResult] = useState(null);
    const [hideRecommendation, setHideRecommendation] = useState(true);

    useEffect(() => {
        (function () {
            fetch(`/api/algoStats?planId=` + props.planId + "&all=" + (filtered ? "0" : "1"))
                .then(res => res.json())
                .then(text => {
                    console.log(text);
                    setData(text);
                });

            fetch(`/api/allActiveTrades`)
                .then(res => res.json())
                .then(text => {
                    console.log("allActiveTrades", text);
                    setActiveTrades(text);
                });
        })();
    }, [filtered, props.planId, updates]);

    useEffect(() => {
        (function () {
            setSavedSearches([]);
            fetch(`/api/userSettings?userId=` + props.userId + `&section=algoStats`)
                .then(res => res.json())
                .then(text => {
                    console.log("saved searches", text);
                    if (text.settings)
                        setSavedSearches(text.settings);
                });
        })();
    }, [props.userId, updates]);

    function getSummaryArray() {
        let stats = { count: 0, winners: 0, losers: 0, winningPct: 0.0, netProfit: 0.0, avgProfit: 0.0, avgWin: 0.0, avgLoss: 0.0, maxWin: 0.0, maxLoss: 0.0, totalProfit: 0.0, kelly: 0.0, avgRobustness: 0, totalRobustness: 0, algoCount: 0, avgMaxDrawdown: 0, totalMaxDrawdown: 0, totalWeightedSharpe: 0, totalSharpeWeight: 0, avgSharpe: 0 }

        let filteredAlgos = getStats();
        filteredAlgos.forEach(algo => {
            const netProfit = (algo.avg_profit * algo.count);
            const winners = Math.round((algo.winning_percentage / 100 * algo.count));
            const losers = algo.count - winners;
            const winnersProfit = algo.avg_win * winners;
            const losersProfit = algo.avg_loss * losers;
            const totalWinners = stats.winners + winners;
            const totalLosers = stats.losers + losers;
            if (totalWinners) stats.avgWin = ((stats.avgWin * stats.winners) + (winnersProfit)) / totalWinners;
            if (totalLosers) stats.avgLoss = ((stats.avgLoss * stats.losers) + (losersProfit)) / totalLosers;

            stats.winners += winners;
            stats.losers += losers;
            stats.netProfit += netProfit;
            stats.count += algo.count;
            stats.totalRobustness += algo.robustness;
            stats.totalMaxDrawdown += algo.max_drawdown;
            const weight = (algo.avg_duration || 0) * (algo.count || 0);
            stats.totalWeightedSharpe += (algo.sharpe || 0) * weight;
            stats.totalSharpeWeight += weight;
            ++stats.algoCount;
        });

        stats.winningPct = (stats.winners / (stats.count) * 100);
        stats.avgProfit = stats.netProfit / stats.count;
        const probabilityOfWinning = (stats.winningPct / 100);
        const winLossRatio = Math.abs(stats.avgWin / stats.avgLoss);
        stats.kelly = (probabilityOfWinning - ((1 - probabilityOfWinning) / winLossRatio)) * 100
        stats.avgRobustness = stats.totalRobustness / stats.algoCount;
        stats.avgMaxDrawdown = stats.totalMaxDrawdown / stats.algoCount;
        stats.avgSharpe = stats.totalSharpeWeight > 0 ? stats.totalWeightedSharpe / stats.totalSharpeWeight : 0;
        return [stats];
    }

    function getDataRanges() {
        let ranges = {
            duration: [undefined, undefined],
            avgProfit: [undefined, undefined],
            tradeCount: [undefined, undefined],
            robustness: [0, 10]
        }

        data.filter(s => s.years === years)
            .forEach(a => {
                if (ranges.duration[0] === undefined || a.avg_duration < ranges.duration[0]) {
                    ranges.duration[0] = a.avg_duration;
                }
                if (ranges.duration[1] === undefined || a.avg_duration > ranges.duration[1]) {
                    ranges.duration[1] = a.avg_duration;
                }
                if (ranges.avgProfit[0] === undefined || a.avg_profit < ranges.avgProfit[0]) {
                    ranges.avgProfit[0] = a.avg_profit;
                }
                if (ranges.avgProfit[1] === undefined || a.avg_profit > ranges.avgProfit[1]) {
                    ranges.avgProfit[1] = a.avg_profit;
                }
                if (ranges.tradeCount[0] === undefined || a.count < ranges.tradeCount[0]) {
                    ranges.tradeCount[0] = a.count;
                }
                if (ranges.tradeCount[1] === undefined || a.count > ranges.tradeCount[1]) {
                    ranges.tradeCount[1] = a.count;
                }
            })

        return ranges;
    }

    function getStats() {
        return data
            .filter(a => a.winning_percentage >= winRateFilter[0] && a.winning_percentage <= winRateFilter[1])
            .filter(a => a.avg_duration >= durationFilter[0] && a.avg_duration <= durationFilter[1])
            .filter(a => a.avg_profit >= avgProfitFilter[0] && a.avg_profit <= avgProfitFilter[1])
            .filter(a => a.count >= tradeCountFilter[0] && a.count <= tradeCountFilter[1])
            .filter(a => a.algo_robustness_overall >= robustnessFilter[0] && a.algo_robustness_overall <= robustnessFilter[1])
            .filter(a => symbolFilter === null || a.trade_symbol === symbolFilter)
            .filter(a => algoFilter === null || a.display_name === algoFilter)
            .filter(a => algoTypeFilter === null || a.algo_type === algoTypeFilter)
            .filter(a => algoLongShortFilter === null || a.short === algoLongShortFilter)
            .filter(s => s.years === years).map(stat => {

                const probabilityOfWinning = (stat.winning_percentage / 100);
                const winLossRatio = stat.avg_loss === 0 ? stat.avg_win : Math.abs(stat.avg_win / stat.avg_loss);
                const kelly = probabilityOfWinning === 0 ? 0 : (probabilityOfWinning - ((1 - probabilityOfWinning) / winLossRatio)) * 100
                const activeTrade = activeTrades.find(t => t.algoId === stat.algoId);

                return {
                    display_name: stat.display_name,
                    entry_speed: stat.entry_speed,
                    winning_percentage: stat.winning_percentage,
                    avg_profit: stat.avg_profit,
                    avg_win: stat.avg_win,
                    avg_loss: stat.avg_loss,
                    win_loss_ratio: winLossRatio,
                    max_win_loss_ratio: Math.abs(stat.max_win / stat.max_loss),
                    avg_duration: stat.avg_duration,
                    entry_lookback: stat.entry_lookback,
                    max_win: stat.max_win,
                    max_loss: stat.max_loss,
                    trade_symbol: stat.trade_symbol,
                    count: stat.count,
                    algo_type: stat.algo_type,
                    algoId: stat.algoId,
                    percentage: stat.percentage,
                    kelly: kelly,
                    net_profit: stat.avg_profit * stat.count,
                    annual_profit: stat.years > 0 ? (stat.avg_profit * stat.count) / stat.years : 0,
                    robustness: stat.algo_robustness_overall,
                    max_correlation: stat.max_correlation,
                    max_drawdown: stat.max_drawdown,
                    cagr: stat.cagr,
                    net_cagr: stat.percentage ? stat.cagr * stat.percentage / 100 : null,
                    net_max_drawdown: stat.percentage ? stat.max_drawdown * stat.percentage / 100 : null,
                    net_avg_profit: stat.percentage ? stat.avg_profit * stat.percentage / 100 : null,
                    expectancy: 1 + ((stat.winning_percentage / 100 * winLossRatio) - (1 - stat.winning_percentage / 100)),
                    current_trade_profit: activeTrade ? (activeTrade.current_price - activeTrade.close) / activeTrade.close * 100 : null,
                    sharpe: stat.sharpe
                }
            })
    }

    function algoLinkFormatter(cell, row) {
        let algoid = row.algoId;

        return (
            <div className='sameline'>
                <AlgoDrawer link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
                &nbsp;<AlgoQuickManage role={props.role} algoId={row.algoId} planId={props.planId} />
            </div>
        )
    }

    async function onActionClicked(algoId) {
        if (props.onAlgoAction) {
            await props.onAlgoAction(algoId);
            setUpdates(updates + 1);
        }
    }

    function selectAlgoFormatter(cell, row) {
        return <Link onClick={() => onActionClicked(row.algoId)}><LibraryAddIcon /></Link>
    }

    function getRecommendations() {
        if (recommendations)
            return recommendations.map(rec => {
                return {
                    ...rec,
                    win_loss_ratio: rec.avg_loss === 0 ? rec.avg_win : Math.abs(rec.avg_win / rec.avg_loss)
                }
            })
        else
            return [];
    }

    async function onLoadRecommendations() {
        setRecommendations(null);
        const url = `/api/planAlgoWizard?planId=` + props.planId + "&symbol=" + searchSymbol + "&algoType=" + searchAlgoType + "&maxCorrelation=" + searchMaxCorrelation;
        let recs = await (await fetch(url)).json();
        setRecommendations(recs);
    }

    function getUniqueSymbols() {
        return [...new Set(data.map(trade => trade.trade_symbol))].sort();
    }
    function getUniqueAlgos() {
        return [...new Set(data.map(trade => trade.display_name))].sort();
    }
    function getUniqueAlgoTypes() {
        return [...new Set(data.map(trade => trade.algo_type))].sort();
    }

    function loadActiveSavedSearch(name) {
        let settings = savedSearches.find(settings => settings.name === name);
        console.log("Loading settings...", name, settings);
        if (settings) {
            setActiveSavedQuery(name);
            let config = settings.config;
            setWinRateFilter(config.winRate);
            setYears(config.years);
            setAvgProfitFilter(config.avgProfit)

            if (config.planOnly) setFiltered(true);
            else setFiltered(false);

            setTradeCountFilter(config.tradeCount);

            if (config.longShortFilter) setAlgoLongShortFilter(config.longShortFilter);
            else setAlgoLongShortFilter(null);

            if (config.algoTypeFilter) setAlgoTypeFilter(config.algoTypeFilter);
            else setAlgoTypeFilter(null);

            setRobustnessFilter(config.robustness);
        }
    }

    async function deleteActiveSavedSearch() {
        if (activeSavedQuery) {
            console.log("Deleting ", activeSavedQuery);
            const url = "/api/userSettingsDelete?userId=" + props.userId + "&section=algoStats&name=" + activeSavedQuery
            console.log(url);
            const r = await (await fetch(url, {
                method: 'POST',
            })).json();
            console.log("Result from api call", r);
            setResult(r);
            setActiveSavedQuery(null);
            setUpdates(updates + 1);
        }
    }

    async function saveSearch() {
        let settings = {};
        settings.name = saveSearchName;
        settings.winRate = winRateFilter;
        settings.duration = durationFilter;
        settings.avgProfit = avgProfitFilter;
        settings.robustness = robustnessFilter;
        settings.tradeCount = tradeCountFilter;
        settings.symbol = symbolFilter;
        settings.years = years;
        settings.planOnly = filtered
        settings.longShortFilter = algoLongShortFilter;
        settings.algoTypeFilter = algoTypeFilter;


        const url = "/api/userSettingsSave?userId=" + props.userId + "&section=algoStats&name=" + saveSearchName
        console.log(url);
        const r = await (await fetch(url, {
            method: 'POST',
            body: JSON.stringify(settings)
        })).json();
        console.log("Result from api call", r);
        setResult(r);

        setSaveSearchName("");
        setUpdates(updates + 1);
    }

    let dataRanges = getDataRanges();

    return (
        <>
            <hr></hr>
            <center>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <center>Performance Filters</center>
                    </AccordionSummary>
                    <AccordionDetails>

                        <table width={500}>
                            <tr className='bg-transparent'>
                                <td width="100">Win Rate</td>
                                <td>
                                    <Slider onChange={(e, newValue) => setWinRateFilter(newValue)} min={0} max={100} value={winRateFilter} valueLabelDisplay="auto" shiftStep={30} step={5} marks />
                                </td>
                            </tr>
                            <tr className='bg-transparent'>
                                <td>Avg Duration</td>
                                <td>
                                    <Slider onChange={(e, newValue) => setDurationFilter(newValue)} min={dataRanges.duration[0]} max={dataRanges.duration[1]} value={durationFilter} valueLabelDisplay="auto" shiftStep={5} step={1} marks />
                                </td>
                            </tr>

                            <tr className='bg-transparent'>
                                <td>Avg Profit</td>
                                <td>
                                    <Slider onChange={(e, newValue) => setAvgProfitFilter(newValue)} min={dataRanges.avgProfit[0]} max={dataRanges.avgProfit[1]} value={avgProfitFilter} valueLabelDisplay="auto" shiftStep={5} step={.1} marks />
                                </td>
                            </tr>
                            <tr className='bg-transparent'>
                                <td>Robustness</td>
                                <td>
                                    <Slider onChange={(e, newValue) => setRobustnessFilter(newValue)} min={dataRanges.robustness[0]} max={dataRanges.robustness[1]} value={robustnessFilter} valueLabelDisplay="auto" shiftStep={5} step={1} marks />
                                </td>
                            </tr>
                            <tr className='bg-transparent'>
                                <td>Trade Count</td>
                                <td>
                                    <Slider onChange={(e, newValue) => setTradeCountFilter(newValue)} min={dataRanges.tradeCount[0]} max={dataRanges.tradeCount[1]} value={tradeCountFilter} valueLabelDisplay="auto" shiftStep={5} step={1} marks />
                                </td>
                            </tr>
                        </table>
                    </AccordionDetails>
                </Accordion>

                <br></br>
                <table width={500}>

                    <tr className='bg-transparent'>
                        <td>Symbol</td>
                        <td>
                            <Dropdown onSelect={(e) => setSymbolFilter(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {symbolFilter}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='group' eventKey={null} value={null}>None</Dropdown.Item>
                                    {getUniqueSymbols().map(sym => {
                                        return (
                                            <Dropdown.Item as='sym' eventKey={sym} value={sym}>{sym}</Dropdown.Item>
                                        )
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>

                    <tr className='bg-transparent'>
                        <td>Algo</td>
                        <td>
                            <Dropdown onSelect={(e) => setAlgoFilter(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {algoFilter}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='group' eventKey={null} value={null}>None</Dropdown.Item>
                                    {getUniqueAlgos().map(a => {
                                        return (
                                            <Dropdown.Item as='algo' eventKey={a} value={a}>{a}</Dropdown.Item>
                                        )
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>

                    <tr className='bg-transparent'>
                        <td>Algo Type</td>
                        <td>
                            <Dropdown onSelect={(e) => setAlgoTypeFilter(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {algoTypeFilter}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='group' eventKey={null} value={null}>None</Dropdown.Item>
                                    {getUniqueAlgoTypes().map(a => {
                                        return (
                                            <Dropdown.Item as='algoType' eventKey={a} value={a}>{a}</Dropdown.Item>
                                        )
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                    <tr className='bg-transparent'>
                        <td>Long / Short</td>
                        <td>
                            <Dropdown onSelect={(e) => setAlgoLongShortFilter(e === null ? null : Number(e))}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {algoLongShortFilter === null ? "All" : (algoLongShortFilter === 1 ? "Short" : "Long")}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='algolongshort' eventKey={null} value={null}>All</Dropdown.Item>
                                    <Dropdown.Item as='algolongshort' eventKey={0} value={0}>Long</Dropdown.Item>
                                    <Dropdown.Item as='algolongshort' eventKey={1} value={1}>Short</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                    <tr className='bg-transparent'>
                        <td>Algo Universe</td>
                        <td>
                            <Dropdown onSelect={(e) => setFiltered(Number(e) === 1 ? true : false)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {filtered ? "Plan Only" : "All"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='algoUniverse' eventKey={1} value={1}>Plan Only</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={0} value={0}>All</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                    <tr className='bg-transparent'>
                        <td>Metrics</td>
                        <td>
                            <Dropdown onSelect={(e) => setYears(Number(e))}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    {years === 0 ? "Live Trades" : (years + " Year Backtest")}
                                </Dropdown.Toggle>
                                <Dropdown.Menu  >
                                    <Dropdown.Item as='algoUniverse' eventKey={0} value={0}>Live Trades</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={1} value={1}>1 Year Backtest</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={2} value={2}>2 Year Backtest</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={3} value={3}>3 Year Backtest</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={5} value={5}>5 Year Backtest</Dropdown.Item>
                                    <Dropdown.Item as='algoUniverse' eventKey={10} value={10}>10 Year Backtest</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                </table>
            </center >
            <hr></hr>

            <center>
                <Dropdown onSelect={(e) => loadActiveSavedSearch(e)}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        {activeSavedQuery ? activeSavedQuery : "Saved Searches"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu  >
                        {savedSearches.map(query => {
                            return (
                                <Dropdown.Item as='q' eventKey={query.name} value={query.name}><b>{query.name}</b></Dropdown.Item>
                            )
                        })}
                    </Dropdown.Menu>
                </Dropdown>
                💾&nbsp;
                <Tooltip textClass={"tooltip-link"} text={"SAVE THIS SEARCH"} width={600} borderWidth={"1px"} position="right center" >
                    <>
                        Name: <input type="text" placeholder="Name" onChange={(e) => setSaveSearchName(e.target.value)} />
                        <br></br>
                        <br></br>
                        <button class="btn btn-primary" onClick={() => saveSearch()} type="button">Save</button>
                    </>
                </Tooltip>
                {activeSavedQuery ?
                    <>
                        &nbsp;&nbsp;|&nbsp;&nbsp;<Link onClick={() => deleteActiveSavedSearch()}>DELETE THIS SEARCH</Link>
                    </>
                    :
                    null
                }
                &nbsp;💾

            </center >
            <RichTable data={getSummaryArray()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algos', field: 'algoCount', formatter: tableHelpers.intFormatter, hidden: props.mobileView },
                { title: 'Trades', field: 'count', formatter: tableHelpers.intFormatter, hidden: props.mobileView },
                { title: 'Win %', field: 'winningPct', formatter: tableHelpers.percentFormatter },
                { title: 'Avg Profit', field: 'avgProfit', formatter: tableHelpers.percentFormatter },
                { title: 'Avg Win', field: 'avgWin', formatter: tableHelpers.percentFormatter },
                { title: 'Avg Loss', field: 'avgLoss', formatter: tableHelpers.percentFormatter },
                { title: 'Robustness', field: 'avgRobustness', formatter: tableHelpers.decimalFormatter, hidden: props.mobileView },
                { title: 'Avg Max DD', field: 'avgMaxDrawdown', formatter: tableHelpers.percentFormatter, hidden: props.mobileView },
                { title: 'Avg Sharpe', field: 'avgSharpe', formatter: tableHelpers.decimalFormatter, hidden: props.mobileView }
            ]} />

            {
                props.onAlgoAction ?
                    <>
                        <Link className="bold-big" onClick={() => setHideRecommendation(false)}>Get a Recommendation</Link>

                        <Drawer open={!hideRecommendation} onClose={() => setHideRecommendation(true)}
                            PaperProps={{
                                sx: { width: "90%" },
                            }}
                        >
                            <div style={{ padding: "20px" }}>

                                <Dropdown onSelect={(e) => setSearchSymbol(e)}>
                                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                        {searchSymbol}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu  >
                                        {getUniqueSymbols().map(sym => {
                                            return (
                                                <Dropdown.Item as='searchSymbol' eventKey={sym} value={sym}>{sym}</Dropdown.Item>
                                            )
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>

                                <br></br>
                                <div class="sameline">
                                    Algo Type:
                                    <Dropdown width="150" onSelect={(e) => setSearchAlgoType(e)}>
                                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                            {searchAlgoType}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu  >
                                            <Dropdown.Item as='a' eventKey={"Mean Reversion"} value={"Mean Reversion"}>Mean Reversion</Dropdown.Item>
                                            <Dropdown.Item as='g' eventKey={"Trend"} value={"Trend"}>Trend</Dropdown.Item>
                                            <Dropdown.Item as='b' eventKey={"Candlestick"} value={"Candlestick"}>Candlestick</Dropdown.Item>
                                            <Dropdown.Item as='c' eventKey={"Momentum"} value={"Momentum"}>Momentum</Dropdown.Item>
                                            <Dropdown.Item as='d' eventKey={"Calendar"} value={"Calendar"}>Calendar</Dropdown.Item>
                                            <Dropdown.Item as='e' eventKey={"Breadth"} value={"Breadth"}>Breadth</Dropdown.Item>
                                            <Dropdown.Item as='f' eventKey={"Intermarket"} value={"Intermarket"}>Intermarket</Dropdown.Item>
                                            <Dropdown.Item as='h' eventKey={"Volatility"} value={"Volatility"}>Volatility</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    Max Correlation:
                                    <Dropdown width="150" onSelect={(e) => setSearchMaxCorrelation(e)}>
                                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                            {searchMaxCorrelation}%
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu  >
                                            <Dropdown.Item as='a' eventKey={20} value={20}>20%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={30} value={30}>30%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={40} value={40}>40%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={50} value={50}>50%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={60} value={60}>60%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={70} value={70}>70%</Dropdown.Item>
                                            <Dropdown.Item as='a' eventKey={100} value={100}>100%</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <br></br>
                                <button class="btn btn-secondary" onClick={() => onLoadRecommendations()}>Search</button>
                                <RichTable data={getRecommendations()} className="table-striped table-hover table-condensed" mappers={[
                                    { title: 'Algo', field: 'primary_display_name', sorters: true },
                                    { title: 'Action', field: 'algoId', formatter: selectAlgoFormatter },
                                    { title: 'CAGR', field: 'cagr', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                                    { title: 'Max DD', field: 'max_drawdown', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                                    { title: 'Win Rate', field: 'winning_percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                                    { title: 'W/L Ratio', field: 'win_loss_ratio', formatter: tableHelpers.decimalFormatter, sorters: true },
                                    { title: 'Robustness', field: 'overall', formatter: tableHelpers.decimalFormatter, sorters: true },
                                    { title: 'Max Correlation', field: 'maxCorrelation', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                                ]} />

                            </div>
                        </Drawer>
                    </>
                    :
                    null
            }


            <br></br>
            <br></br>
            <RichTable data={getStats()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algo', field: 'display_name', formatter: algoLinkFormatter, sorters: true, filter: 'text' },
                { title: 'Symbol', field: 'trade_symbol', sorters: true, filter: 'text' },
                { title: 'Select', field: 'idalgos', hidden: !props.onAlgoAction, formatter: selectAlgoFormatter },
                { title: 'Type', field: 'algo_type', hidden: props.mobileView, sorters: true, filter: 'choice' },
                { title: 'Entry Lookback', field: 'entry_lookback', hidden: props.mobileView, sorters: true, formatter: tableHelpers.intFormatter },
                { title: 'Allocation', field: 'percentage', formatter: tableHelpers.percentFormatter, hidden: props.mobileView, sorters: true },
                { title: 'Trades', field: 'count', formatter: tableHelpers.intFormatter, hidden: props.mobileView, sorters: true },
                { title: 'Robustness', field: 'robustness', formatter: tableHelpers.decimalFormatter, hidden: props.mobileView, sorters: true },
                { title: 'CAGR', field: 'cagr', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                { title: 'Max DD', field: 'max_drawdown', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                { title: 'Sharpe', field: 'sharpe', formatter: tableHelpers.decimalFormatter, hidden: false, sorters: true },
                { title: 'Win %', field: 'winning_percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true, hidden: props.mobileView },
                { title: 'W/L Ratio', field: 'win_loss_ratio', formatter: tableHelpers.decimalFormatter, hidden: props.mobileView, sorters: true },
                { title: 'Expectancy', field: 'expectancy', formatter: tableHelpers.decimalFormatter, hidden: props.mobileView, sorters: true },
                { title: 'Avg P/L', field: 'avg_profit', formatter: tableHelpers.percentChangeFormatterOneDecimal, sorters: true },
                { title: 'Current Trade', field: 'current_trade_profit', formatter: tableHelpers.percentChangeFormatter, hidden: props.mobileView, sorters: true },
                { title: 'Net CAGR', field: 'net_cagr', formatter: tableHelpers.percentFormatterOneDecimal, hidden: props.mobileView, sorters: true },
                { title: 'Net Max DD', field: 'net_max_drawdown', formatter: tableHelpers.percentFormatterOneDecimal, hidden: props.mobileView, sorters: true },
                { title: 'Duration', field: 'avg_duration', formatter: tableHelpers.intFormatter, hidden: props.mobileView, sorters: true },
            ]} />

            <br></br>
            <br></br>

            <ActionResult result={result} />
        </>
    );
}

export default AlgoStats;